// source: proto/occpb/expired_position.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_type_date_pb = require('../../google/type/date_pb.js');
goog.object.extend(proto, google_type_date_pb);
goog.exportSymbol('proto.occpb.BatchProcessExpiredPositionRequest', null, global);
goog.exportSymbol('proto.occpb.BatchProcessExpiredPositionResponse', null, global);
goog.exportSymbol('proto.occpb.EmptyResponse', null, global);
goog.exportSymbol('proto.occpb.ExpiredPosition', null, global);
goog.exportSymbol('proto.occpb.ListExpiredPositionRequest', null, global);
goog.exportSymbol('proto.occpb.ListExpiredPositionResponse', null, global);
goog.exportSymbol('proto.occpb.ProcessExpiredPositionRequest', null, global);
goog.exportSymbol('proto.occpb.UpdateExpiredPositionRequest', null, global);
goog.exportSymbol('proto.occpb.UpdateExpiredPositionResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.occpb.ExpiredPosition = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.occpb.ExpiredPosition, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.occpb.ExpiredPosition.displayName = 'proto.occpb.ExpiredPosition';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.occpb.ListExpiredPositionRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.occpb.ListExpiredPositionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.occpb.ListExpiredPositionRequest.displayName =
    'proto.occpb.ListExpiredPositionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.occpb.ListExpiredPositionResponse = function (opt_data) {
  jspb.Message.initialize(
    this,
    opt_data,
    0,
    -1,
    proto.occpb.ListExpiredPositionResponse.repeatedFields_,
    null
  );
};
goog.inherits(proto.occpb.ListExpiredPositionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.occpb.ListExpiredPositionResponse.displayName =
    'proto.occpb.ListExpiredPositionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.occpb.UpdateExpiredPositionRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.occpb.UpdateExpiredPositionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.occpb.UpdateExpiredPositionRequest.displayName =
    'proto.occpb.UpdateExpiredPositionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.occpb.UpdateExpiredPositionResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.occpb.UpdateExpiredPositionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.occpb.UpdateExpiredPositionResponse.displayName =
    'proto.occpb.UpdateExpiredPositionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.occpb.ProcessExpiredPositionRequest = function (opt_data) {
  jspb.Message.initialize(
    this,
    opt_data,
    0,
    -1,
    proto.occpb.ProcessExpiredPositionRequest.repeatedFields_,
    null
  );
};
goog.inherits(proto.occpb.ProcessExpiredPositionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.occpb.ProcessExpiredPositionRequest.displayName =
    'proto.occpb.ProcessExpiredPositionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.occpb.BatchProcessExpiredPositionRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.occpb.BatchProcessExpiredPositionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.occpb.BatchProcessExpiredPositionRequest.displayName =
    'proto.occpb.BatchProcessExpiredPositionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.occpb.BatchProcessExpiredPositionResponse = function (opt_data) {
  jspb.Message.initialize(
    this,
    opt_data,
    0,
    -1,
    proto.occpb.BatchProcessExpiredPositionResponse.repeatedFields_,
    null
  );
};
goog.inherits(proto.occpb.BatchProcessExpiredPositionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.occpb.BatchProcessExpiredPositionResponse.displayName =
    'proto.occpb.BatchProcessExpiredPositionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.occpb.EmptyResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.occpb.EmptyResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.occpb.EmptyResponse.displayName = 'proto.occpb.EmptyResponse';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.occpb.ExpiredPosition.prototype.toObject = function (opt_includeInstance) {
    return proto.occpb.ExpiredPosition.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.occpb.ExpiredPosition} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.occpb.ExpiredPosition.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        id: jspb.Message.getFieldWithDefault(msg, 1, 0),
        systemDate:
          (f = msg.getSystemDate()) &&
          google_type_date_pb.Date.toObject(includeInstance, f),
        accountId: jspb.Message.getFieldWithDefault(msg, 3, 0),
        correspondent: jspb.Message.getFieldWithDefault(msg, 4, ''),
        accountNo: jspb.Message.getFieldWithDefault(msg, 5, ''),
        symbol: jspb.Message.getFieldWithDefault(msg, 6, ''),
        underlyingSymbol: jspb.Message.getFieldWithDefault(msg, 7, ''),
        strikePrice: jspb.Message.getFieldWithDefault(msg, 8, ''),
        expirationDate:
          (f = msg.getExpirationDate()) &&
          google_type_date_pb.Date.toObject(includeInstance, f),
        pc: jspb.Message.getFieldWithDefault(msg, 10, ''),
        secType: jspb.Message.getFieldWithDefault(msg, 11, ''),
        closingPrice: jspb.Message.getFieldWithDefault(msg, 12, ''),
        underlyingClosingPrice: jspb.Message.getFieldWithDefault(msg, 13, ''),
        inTheMoney: jspb.Message.getBooleanFieldWithDefault(msg, 14, false),
        itmOtmAmount: jspb.Message.getFieldWithDefault(msg, 15, ''),
        multiplier: jspb.Message.getFieldWithDefault(msg, 16, ''),
        side: jspb.Message.getFieldWithDefault(msg, 17, ''),
        tdQty: jspb.Message.getFieldWithDefault(msg, 18, ''),
        remainingQty: jspb.Message.getFieldWithDefault(msg, 19, ''),
        eedQty: jspb.Message.getFieldWithDefault(msg, 20, ''),
        eedDeclationQty: jspb.Message.getFieldWithDefault(msg, 21, ''),
        dnedQty: jspb.Message.getFieldWithDefault(msg, 22, ''),
        dnedDeclationQty: jspb.Message.getFieldWithDefault(msg, 23, ''),
        assignmentQty: jspb.Message.getFieldWithDefault(msg, 24, ''),
        expirationQty: jspb.Message.getFieldWithDefault(msg, 25, ''),
        exerciseQty: jspb.Message.getFieldWithDefault(msg, 26, ''),
        source: jspb.Message.getFieldWithDefault(msg, 27, ''),
        status: jspb.Message.getFieldWithDefault(msg, 28, ''),
        originalCusip: jspb.Message.getFieldWithDefault(msg, 29, ''),
        cusip: jspb.Message.getFieldWithDefault(msg, 30, ''),
        processDate:
          (f = msg.getProcessDate()) &&
          google_type_date_pb.Date.toObject(includeInstance, f),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.occpb.ExpiredPosition}
 */
proto.occpb.ExpiredPosition.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.occpb.ExpiredPosition();
  return proto.occpb.ExpiredPosition.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.occpb.ExpiredPosition} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.occpb.ExpiredPosition}
 */
proto.occpb.ExpiredPosition.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {number} */ (reader.readUint32());
        msg.setId(value);
        break;
      case 2:
        var value = new google_type_date_pb.Date();
        reader.readMessage(value, google_type_date_pb.Date.deserializeBinaryFromReader);
        msg.setSystemDate(value);
        break;
      case 3:
        var value = /** @type {number} */ (reader.readUint32());
        msg.setAccountId(value);
        break;
      case 4:
        var value = /** @type {string} */ (reader.readString());
        msg.setCorrespondent(value);
        break;
      case 5:
        var value = /** @type {string} */ (reader.readString());
        msg.setAccountNo(value);
        break;
      case 6:
        var value = /** @type {string} */ (reader.readString());
        msg.setSymbol(value);
        break;
      case 7:
        var value = /** @type {string} */ (reader.readString());
        msg.setUnderlyingSymbol(value);
        break;
      case 8:
        var value = /** @type {string} */ (reader.readString());
        msg.setStrikePrice(value);
        break;
      case 9:
        var value = new google_type_date_pb.Date();
        reader.readMessage(value, google_type_date_pb.Date.deserializeBinaryFromReader);
        msg.setExpirationDate(value);
        break;
      case 10:
        var value = /** @type {string} */ (reader.readString());
        msg.setPc(value);
        break;
      case 11:
        var value = /** @type {string} */ (reader.readString());
        msg.setSecType(value);
        break;
      case 12:
        var value = /** @type {string} */ (reader.readString());
        msg.setClosingPrice(value);
        break;
      case 13:
        var value = /** @type {string} */ (reader.readString());
        msg.setUnderlyingClosingPrice(value);
        break;
      case 14:
        var value = /** @type {boolean} */ (reader.readBool());
        msg.setInTheMoney(value);
        break;
      case 15:
        var value = /** @type {string} */ (reader.readString());
        msg.setItmOtmAmount(value);
        break;
      case 16:
        var value = /** @type {string} */ (reader.readString());
        msg.setMultiplier(value);
        break;
      case 17:
        var value = /** @type {string} */ (reader.readString());
        msg.setSide(value);
        break;
      case 18:
        var value = /** @type {string} */ (reader.readString());
        msg.setTdQty(value);
        break;
      case 19:
        var value = /** @type {string} */ (reader.readString());
        msg.setRemainingQty(value);
        break;
      case 20:
        var value = /** @type {string} */ (reader.readString());
        msg.setEedQty(value);
        break;
      case 21:
        var value = /** @type {string} */ (reader.readString());
        msg.setEedDeclationQty(value);
        break;
      case 22:
        var value = /** @type {string} */ (reader.readString());
        msg.setDnedQty(value);
        break;
      case 23:
        var value = /** @type {string} */ (reader.readString());
        msg.setDnedDeclationQty(value);
        break;
      case 24:
        var value = /** @type {string} */ (reader.readString());
        msg.setAssignmentQty(value);
        break;
      case 25:
        var value = /** @type {string} */ (reader.readString());
        msg.setExpirationQty(value);
        break;
      case 26:
        var value = /** @type {string} */ (reader.readString());
        msg.setExerciseQty(value);
        break;
      case 27:
        var value = /** @type {string} */ (reader.readString());
        msg.setSource(value);
        break;
      case 28:
        var value = /** @type {string} */ (reader.readString());
        msg.setStatus(value);
        break;
      case 29:
        var value = /** @type {string} */ (reader.readString());
        msg.setOriginalCusip(value);
        break;
      case 30:
        var value = /** @type {string} */ (reader.readString());
        msg.setCusip(value);
        break;
      case 31:
        var value = new google_type_date_pb.Date();
        reader.readMessage(value, google_type_date_pb.Date.deserializeBinaryFromReader);
        msg.setProcessDate(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.occpb.ExpiredPosition.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.occpb.ExpiredPosition.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.occpb.ExpiredPosition} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.occpb.ExpiredPosition.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeUint32(1, f);
  }
  f = message.getSystemDate();
  if (f != null) {
    writer.writeMessage(2, f, google_type_date_pb.Date.serializeBinaryToWriter);
  }
  f = message.getAccountId();
  if (f !== 0) {
    writer.writeUint32(3, f);
  }
  f = message.getCorrespondent();
  if (f.length > 0) {
    writer.writeString(4, f);
  }
  f = message.getAccountNo();
  if (f.length > 0) {
    writer.writeString(5, f);
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(6, f);
  }
  f = message.getUnderlyingSymbol();
  if (f.length > 0) {
    writer.writeString(7, f);
  }
  f = message.getStrikePrice();
  if (f.length > 0) {
    writer.writeString(8, f);
  }
  f = message.getExpirationDate();
  if (f != null) {
    writer.writeMessage(9, f, google_type_date_pb.Date.serializeBinaryToWriter);
  }
  f = message.getPc();
  if (f.length > 0) {
    writer.writeString(10, f);
  }
  f = message.getSecType();
  if (f.length > 0) {
    writer.writeString(11, f);
  }
  f = message.getClosingPrice();
  if (f.length > 0) {
    writer.writeString(12, f);
  }
  f = message.getUnderlyingClosingPrice();
  if (f.length > 0) {
    writer.writeString(13, f);
  }
  f = message.getInTheMoney();
  if (f) {
    writer.writeBool(14, f);
  }
  f = message.getItmOtmAmount();
  if (f.length > 0) {
    writer.writeString(15, f);
  }
  f = message.getMultiplier();
  if (f.length > 0) {
    writer.writeString(16, f);
  }
  f = message.getSide();
  if (f.length > 0) {
    writer.writeString(17, f);
  }
  f = message.getTdQty();
  if (f.length > 0) {
    writer.writeString(18, f);
  }
  f = message.getRemainingQty();
  if (f.length > 0) {
    writer.writeString(19, f);
  }
  f = message.getEedQty();
  if (f.length > 0) {
    writer.writeString(20, f);
  }
  f = message.getEedDeclationQty();
  if (f.length > 0) {
    writer.writeString(21, f);
  }
  f = message.getDnedQty();
  if (f.length > 0) {
    writer.writeString(22, f);
  }
  f = message.getDnedDeclationQty();
  if (f.length > 0) {
    writer.writeString(23, f);
  }
  f = message.getAssignmentQty();
  if (f.length > 0) {
    writer.writeString(24, f);
  }
  f = message.getExpirationQty();
  if (f.length > 0) {
    writer.writeString(25, f);
  }
  f = message.getExerciseQty();
  if (f.length > 0) {
    writer.writeString(26, f);
  }
  f = message.getSource();
  if (f.length > 0) {
    writer.writeString(27, f);
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(28, f);
  }
  f = message.getOriginalCusip();
  if (f.length > 0) {
    writer.writeString(29, f);
  }
  f = message.getCusip();
  if (f.length > 0) {
    writer.writeString(30, f);
  }
  f = message.getProcessDate();
  if (f != null) {
    writer.writeMessage(31, f, google_type_date_pb.Date.serializeBinaryToWriter);
  }
};

/**
 * optional uint32 id = 1;
 * @return {number}
 */
proto.occpb.ExpiredPosition.prototype.getId = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};

/**
 * @param {number} value
 * @return {!proto.occpb.ExpiredPosition} returns this
 */
proto.occpb.ExpiredPosition.prototype.setId = function (value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};

/**
 * optional google.type.Date system_date = 2;
 * @return {?proto.google.type.Date}
 */
proto.occpb.ExpiredPosition.prototype.getSystemDate = function () {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 2)
  );
};

/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.occpb.ExpiredPosition} returns this
 */
proto.occpb.ExpiredPosition.prototype.setSystemDate = function (value) {
  return jspb.Message.setWrapperField(this, 2, value);
};

/**
 * Clears the message field making it undefined.
 * @return {!proto.occpb.ExpiredPosition} returns this
 */
proto.occpb.ExpiredPosition.prototype.clearSystemDate = function () {
  return this.setSystemDate(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.occpb.ExpiredPosition.prototype.hasSystemDate = function () {
  return jspb.Message.getField(this, 2) != null;
};

/**
 * optional uint32 account_id = 3;
 * @return {number}
 */
proto.occpb.ExpiredPosition.prototype.getAccountId = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};

/**
 * @param {number} value
 * @return {!proto.occpb.ExpiredPosition} returns this
 */
proto.occpb.ExpiredPosition.prototype.setAccountId = function (value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};

/**
 * optional string correspondent = 4;
 * @return {string}
 */
proto.occpb.ExpiredPosition.prototype.getCorrespondent = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ''));
};

/**
 * @param {string} value
 * @return {!proto.occpb.ExpiredPosition} returns this
 */
proto.occpb.ExpiredPosition.prototype.setCorrespondent = function (value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};

/**
 * optional string account_no = 5;
 * @return {string}
 */
proto.occpb.ExpiredPosition.prototype.getAccountNo = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ''));
};

/**
 * @param {string} value
 * @return {!proto.occpb.ExpiredPosition} returns this
 */
proto.occpb.ExpiredPosition.prototype.setAccountNo = function (value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};

/**
 * optional string symbol = 6;
 * @return {string}
 */
proto.occpb.ExpiredPosition.prototype.getSymbol = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ''));
};

/**
 * @param {string} value
 * @return {!proto.occpb.ExpiredPosition} returns this
 */
proto.occpb.ExpiredPosition.prototype.setSymbol = function (value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};

/**
 * optional string underlying_symbol = 7;
 * @return {string}
 */
proto.occpb.ExpiredPosition.prototype.getUnderlyingSymbol = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ''));
};

/**
 * @param {string} value
 * @return {!proto.occpb.ExpiredPosition} returns this
 */
proto.occpb.ExpiredPosition.prototype.setUnderlyingSymbol = function (value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};

/**
 * optional string strike_price = 8;
 * @return {string}
 */
proto.occpb.ExpiredPosition.prototype.getStrikePrice = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ''));
};

/**
 * @param {string} value
 * @return {!proto.occpb.ExpiredPosition} returns this
 */
proto.occpb.ExpiredPosition.prototype.setStrikePrice = function (value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};

/**
 * optional google.type.Date expiration_date = 9;
 * @return {?proto.google.type.Date}
 */
proto.occpb.ExpiredPosition.prototype.getExpirationDate = function () {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 9)
  );
};

/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.occpb.ExpiredPosition} returns this
 */
proto.occpb.ExpiredPosition.prototype.setExpirationDate = function (value) {
  return jspb.Message.setWrapperField(this, 9, value);
};

/**
 * Clears the message field making it undefined.
 * @return {!proto.occpb.ExpiredPosition} returns this
 */
proto.occpb.ExpiredPosition.prototype.clearExpirationDate = function () {
  return this.setExpirationDate(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.occpb.ExpiredPosition.prototype.hasExpirationDate = function () {
  return jspb.Message.getField(this, 9) != null;
};

/**
 * optional string pc = 10;
 * @return {string}
 */
proto.occpb.ExpiredPosition.prototype.getPc = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ''));
};

/**
 * @param {string} value
 * @return {!proto.occpb.ExpiredPosition} returns this
 */
proto.occpb.ExpiredPosition.prototype.setPc = function (value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};

/**
 * optional string sec_type = 11;
 * @return {string}
 */
proto.occpb.ExpiredPosition.prototype.getSecType = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ''));
};

/**
 * @param {string} value
 * @return {!proto.occpb.ExpiredPosition} returns this
 */
proto.occpb.ExpiredPosition.prototype.setSecType = function (value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};

/**
 * optional string closing_price = 12;
 * @return {string}
 */
proto.occpb.ExpiredPosition.prototype.getClosingPrice = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ''));
};

/**
 * @param {string} value
 * @return {!proto.occpb.ExpiredPosition} returns this
 */
proto.occpb.ExpiredPosition.prototype.setClosingPrice = function (value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};

/**
 * optional string underlying_closing_price = 13;
 * @return {string}
 */
proto.occpb.ExpiredPosition.prototype.getUnderlyingClosingPrice = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ''));
};

/**
 * @param {string} value
 * @return {!proto.occpb.ExpiredPosition} returns this
 */
proto.occpb.ExpiredPosition.prototype.setUnderlyingClosingPrice = function (value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};

/**
 * optional bool in_the_money = 14;
 * @return {boolean}
 */
proto.occpb.ExpiredPosition.prototype.getInTheMoney = function () {
  return /** @type {boolean} */ (
    jspb.Message.getBooleanFieldWithDefault(this, 14, false)
  );
};

/**
 * @param {boolean} value
 * @return {!proto.occpb.ExpiredPosition} returns this
 */
proto.occpb.ExpiredPosition.prototype.setInTheMoney = function (value) {
  return jspb.Message.setProto3BooleanField(this, 14, value);
};

/**
 * optional string itm_otm_amount = 15;
 * @return {string}
 */
proto.occpb.ExpiredPosition.prototype.getItmOtmAmount = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ''));
};

/**
 * @param {string} value
 * @return {!proto.occpb.ExpiredPosition} returns this
 */
proto.occpb.ExpiredPosition.prototype.setItmOtmAmount = function (value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};

/**
 * optional string multiplier = 16;
 * @return {string}
 */
proto.occpb.ExpiredPosition.prototype.getMultiplier = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ''));
};

/**
 * @param {string} value
 * @return {!proto.occpb.ExpiredPosition} returns this
 */
proto.occpb.ExpiredPosition.prototype.setMultiplier = function (value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};

/**
 * optional string side = 17;
 * @return {string}
 */
proto.occpb.ExpiredPosition.prototype.getSide = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ''));
};

/**
 * @param {string} value
 * @return {!proto.occpb.ExpiredPosition} returns this
 */
proto.occpb.ExpiredPosition.prototype.setSide = function (value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};

/**
 * optional string td_qty = 18;
 * @return {string}
 */
proto.occpb.ExpiredPosition.prototype.getTdQty = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ''));
};

/**
 * @param {string} value
 * @return {!proto.occpb.ExpiredPosition} returns this
 */
proto.occpb.ExpiredPosition.prototype.setTdQty = function (value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};

/**
 * optional string remaining_qty = 19;
 * @return {string}
 */
proto.occpb.ExpiredPosition.prototype.getRemainingQty = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ''));
};

/**
 * @param {string} value
 * @return {!proto.occpb.ExpiredPosition} returns this
 */
proto.occpb.ExpiredPosition.prototype.setRemainingQty = function (value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};

/**
 * optional string eed_qty = 20;
 * @return {string}
 */
proto.occpb.ExpiredPosition.prototype.getEedQty = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ''));
};

/**
 * @param {string} value
 * @return {!proto.occpb.ExpiredPosition} returns this
 */
proto.occpb.ExpiredPosition.prototype.setEedQty = function (value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};

/**
 * optional string eed_declation_qty = 21;
 * @return {string}
 */
proto.occpb.ExpiredPosition.prototype.getEedDeclationQty = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ''));
};

/**
 * @param {string} value
 * @return {!proto.occpb.ExpiredPosition} returns this
 */
proto.occpb.ExpiredPosition.prototype.setEedDeclationQty = function (value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};

/**
 * optional string dned_qty = 22;
 * @return {string}
 */
proto.occpb.ExpiredPosition.prototype.getDnedQty = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ''));
};

/**
 * @param {string} value
 * @return {!proto.occpb.ExpiredPosition} returns this
 */
proto.occpb.ExpiredPosition.prototype.setDnedQty = function (value) {
  return jspb.Message.setProto3StringField(this, 22, value);
};

/**
 * optional string dned_declation_qty = 23;
 * @return {string}
 */
proto.occpb.ExpiredPosition.prototype.getDnedDeclationQty = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 23, ''));
};

/**
 * @param {string} value
 * @return {!proto.occpb.ExpiredPosition} returns this
 */
proto.occpb.ExpiredPosition.prototype.setDnedDeclationQty = function (value) {
  return jspb.Message.setProto3StringField(this, 23, value);
};

/**
 * optional string assignment_qty = 24;
 * @return {string}
 */
proto.occpb.ExpiredPosition.prototype.getAssignmentQty = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 24, ''));
};

/**
 * @param {string} value
 * @return {!proto.occpb.ExpiredPosition} returns this
 */
proto.occpb.ExpiredPosition.prototype.setAssignmentQty = function (value) {
  return jspb.Message.setProto3StringField(this, 24, value);
};

/**
 * optional string expiration_qty = 25;
 * @return {string}
 */
proto.occpb.ExpiredPosition.prototype.getExpirationQty = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 25, ''));
};

/**
 * @param {string} value
 * @return {!proto.occpb.ExpiredPosition} returns this
 */
proto.occpb.ExpiredPosition.prototype.setExpirationQty = function (value) {
  return jspb.Message.setProto3StringField(this, 25, value);
};

/**
 * optional string exercise_qty = 26;
 * @return {string}
 */
proto.occpb.ExpiredPosition.prototype.getExerciseQty = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 26, ''));
};

/**
 * @param {string} value
 * @return {!proto.occpb.ExpiredPosition} returns this
 */
proto.occpb.ExpiredPosition.prototype.setExerciseQty = function (value) {
  return jspb.Message.setProto3StringField(this, 26, value);
};

/**
 * optional string source = 27;
 * @return {string}
 */
proto.occpb.ExpiredPosition.prototype.getSource = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 27, ''));
};

/**
 * @param {string} value
 * @return {!proto.occpb.ExpiredPosition} returns this
 */
proto.occpb.ExpiredPosition.prototype.setSource = function (value) {
  return jspb.Message.setProto3StringField(this, 27, value);
};

/**
 * optional string status = 28;
 * @return {string}
 */
proto.occpb.ExpiredPosition.prototype.getStatus = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 28, ''));
};

/**
 * @param {string} value
 * @return {!proto.occpb.ExpiredPosition} returns this
 */
proto.occpb.ExpiredPosition.prototype.setStatus = function (value) {
  return jspb.Message.setProto3StringField(this, 28, value);
};

/**
 * optional string original_cusip = 29;
 * @return {string}
 */
proto.occpb.ExpiredPosition.prototype.getOriginalCusip = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 29, ''));
};

/**
 * @param {string} value
 * @return {!proto.occpb.ExpiredPosition} returns this
 */
proto.occpb.ExpiredPosition.prototype.setOriginalCusip = function (value) {
  return jspb.Message.setProto3StringField(this, 29, value);
};

/**
 * optional string cusip = 30;
 * @return {string}
 */
proto.occpb.ExpiredPosition.prototype.getCusip = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 30, ''));
};

/**
 * @param {string} value
 * @return {!proto.occpb.ExpiredPosition} returns this
 */
proto.occpb.ExpiredPosition.prototype.setCusip = function (value) {
  return jspb.Message.setProto3StringField(this, 30, value);
};

/**
 * optional google.type.Date process_date = 31;
 * @return {?proto.google.type.Date}
 */
proto.occpb.ExpiredPosition.prototype.getProcessDate = function () {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 31)
  );
};

/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.occpb.ExpiredPosition} returns this
 */
proto.occpb.ExpiredPosition.prototype.setProcessDate = function (value) {
  return jspb.Message.setWrapperField(this, 31, value);
};

/**
 * Clears the message field making it undefined.
 * @return {!proto.occpb.ExpiredPosition} returns this
 */
proto.occpb.ExpiredPosition.prototype.clearProcessDate = function () {
  return this.setProcessDate(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.occpb.ExpiredPosition.prototype.hasProcessDate = function () {
  return jspb.Message.getField(this, 31) != null;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.occpb.ListExpiredPositionRequest.prototype.toObject = function (
    opt_includeInstance
  ) {
    return proto.occpb.ListExpiredPositionRequest.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.occpb.ListExpiredPositionRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.occpb.ListExpiredPositionRequest.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        fromDate:
          (f = msg.getFromDate()) &&
          google_type_date_pb.Date.toObject(includeInstance, f),
        toDate:
          (f = msg.getToDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
        correspondent: jspb.Message.getFieldWithDefault(msg, 3, ''),
        accountNo: jspb.Message.getFieldWithDefault(msg, 4, ''),
        symbol: jspb.Message.getFieldWithDefault(msg, 5, ''),
        originalCusip: jspb.Message.getFieldWithDefault(msg, 6, ''),
        cusip: jspb.Message.getFieldWithDefault(msg, 7, ''),
        usrId: jspb.Message.getFieldWithDefault(msg, 11, 0),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.occpb.ListExpiredPositionRequest}
 */
proto.occpb.ListExpiredPositionRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.occpb.ListExpiredPositionRequest();
  return proto.occpb.ListExpiredPositionRequest.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.occpb.ListExpiredPositionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.occpb.ListExpiredPositionRequest}
 */
proto.occpb.ListExpiredPositionRequest.deserializeBinaryFromReader = function (
  msg,
  reader
) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = new google_type_date_pb.Date();
        reader.readMessage(value, google_type_date_pb.Date.deserializeBinaryFromReader);
        msg.setFromDate(value);
        break;
      case 2:
        var value = new google_type_date_pb.Date();
        reader.readMessage(value, google_type_date_pb.Date.deserializeBinaryFromReader);
        msg.setToDate(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setCorrespondent(value);
        break;
      case 4:
        var value = /** @type {string} */ (reader.readString());
        msg.setAccountNo(value);
        break;
      case 5:
        var value = /** @type {string} */ (reader.readString());
        msg.setSymbol(value);
        break;
      case 6:
        var value = /** @type {string} */ (reader.readString());
        msg.setOriginalCusip(value);
        break;
      case 7:
        var value = /** @type {string} */ (reader.readString());
        msg.setCusip(value);
        break;
      case 11:
        var value = /** @type {number} */ (reader.readUint32());
        msg.setUsrId(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.occpb.ListExpiredPositionRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.occpb.ListExpiredPositionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.occpb.ListExpiredPositionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.occpb.ListExpiredPositionRequest.serializeBinaryToWriter = function (
  message,
  writer
) {
  var f = undefined;
  f = message.getFromDate();
  if (f != null) {
    writer.writeMessage(1, f, google_type_date_pb.Date.serializeBinaryToWriter);
  }
  f = message.getToDate();
  if (f != null) {
    writer.writeMessage(2, f, google_type_date_pb.Date.serializeBinaryToWriter);
  }
  f = message.getCorrespondent();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
  f = message.getAccountNo();
  if (f.length > 0) {
    writer.writeString(4, f);
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(5, f);
  }
  f = message.getOriginalCusip();
  if (f.length > 0) {
    writer.writeString(6, f);
  }
  f = message.getCusip();
  if (f.length > 0) {
    writer.writeString(7, f);
  }
  f = message.getUsrId();
  if (f !== 0) {
    writer.writeUint32(11, f);
  }
};

/**
 * optional google.type.Date from_date = 1;
 * @return {?proto.google.type.Date}
 */
proto.occpb.ListExpiredPositionRequest.prototype.getFromDate = function () {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 1)
  );
};

/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.occpb.ListExpiredPositionRequest} returns this
 */
proto.occpb.ListExpiredPositionRequest.prototype.setFromDate = function (value) {
  return jspb.Message.setWrapperField(this, 1, value);
};

/**
 * Clears the message field making it undefined.
 * @return {!proto.occpb.ListExpiredPositionRequest} returns this
 */
proto.occpb.ListExpiredPositionRequest.prototype.clearFromDate = function () {
  return this.setFromDate(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.occpb.ListExpiredPositionRequest.prototype.hasFromDate = function () {
  return jspb.Message.getField(this, 1) != null;
};

/**
 * optional google.type.Date to_date = 2;
 * @return {?proto.google.type.Date}
 */
proto.occpb.ListExpiredPositionRequest.prototype.getToDate = function () {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 2)
  );
};

/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.occpb.ListExpiredPositionRequest} returns this
 */
proto.occpb.ListExpiredPositionRequest.prototype.setToDate = function (value) {
  return jspb.Message.setWrapperField(this, 2, value);
};

/**
 * Clears the message field making it undefined.
 * @return {!proto.occpb.ListExpiredPositionRequest} returns this
 */
proto.occpb.ListExpiredPositionRequest.prototype.clearToDate = function () {
  return this.setToDate(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.occpb.ListExpiredPositionRequest.prototype.hasToDate = function () {
  return jspb.Message.getField(this, 2) != null;
};

/**
 * optional string correspondent = 3;
 * @return {string}
 */
proto.occpb.ListExpiredPositionRequest.prototype.getCorrespondent = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''));
};

/**
 * @param {string} value
 * @return {!proto.occpb.ListExpiredPositionRequest} returns this
 */
proto.occpb.ListExpiredPositionRequest.prototype.setCorrespondent = function (value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};

/**
 * optional string account_no = 4;
 * @return {string}
 */
proto.occpb.ListExpiredPositionRequest.prototype.getAccountNo = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ''));
};

/**
 * @param {string} value
 * @return {!proto.occpb.ListExpiredPositionRequest} returns this
 */
proto.occpb.ListExpiredPositionRequest.prototype.setAccountNo = function (value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};

/**
 * optional string symbol = 5;
 * @return {string}
 */
proto.occpb.ListExpiredPositionRequest.prototype.getSymbol = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ''));
};

/**
 * @param {string} value
 * @return {!proto.occpb.ListExpiredPositionRequest} returns this
 */
proto.occpb.ListExpiredPositionRequest.prototype.setSymbol = function (value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};

/**
 * optional string original_cusip = 6;
 * @return {string}
 */
proto.occpb.ListExpiredPositionRequest.prototype.getOriginalCusip = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ''));
};

/**
 * @param {string} value
 * @return {!proto.occpb.ListExpiredPositionRequest} returns this
 */
proto.occpb.ListExpiredPositionRequest.prototype.setOriginalCusip = function (value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};

/**
 * optional string cusip = 7;
 * @return {string}
 */
proto.occpb.ListExpiredPositionRequest.prototype.getCusip = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ''));
};

/**
 * @param {string} value
 * @return {!proto.occpb.ListExpiredPositionRequest} returns this
 */
proto.occpb.ListExpiredPositionRequest.prototype.setCusip = function (value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};

/**
 * optional uint32 usr_id = 11;
 * @return {number}
 */
proto.occpb.ListExpiredPositionRequest.prototype.getUsrId = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};

/**
 * @param {number} value
 * @return {!proto.occpb.ListExpiredPositionRequest} returns this
 */
proto.occpb.ListExpiredPositionRequest.prototype.setUsrId = function (value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.occpb.ListExpiredPositionResponse.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.occpb.ListExpiredPositionResponse.prototype.toObject = function (
    opt_includeInstance
  ) {
    return proto.occpb.ListExpiredPositionResponse.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.occpb.ListExpiredPositionResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.occpb.ListExpiredPositionResponse.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        expiredPositionsList: jspb.Message.toObjectList(
          msg.getExpiredPositionsList(),
          proto.occpb.ExpiredPosition.toObject,
          includeInstance
        ),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.occpb.ListExpiredPositionResponse}
 */
proto.occpb.ListExpiredPositionResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.occpb.ListExpiredPositionResponse();
  return proto.occpb.ListExpiredPositionResponse.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.occpb.ListExpiredPositionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.occpb.ListExpiredPositionResponse}
 */
proto.occpb.ListExpiredPositionResponse.deserializeBinaryFromReader = function (
  msg,
  reader
) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = new proto.occpb.ExpiredPosition();
        reader.readMessage(
          value,
          proto.occpb.ExpiredPosition.deserializeBinaryFromReader
        );
        msg.addExpiredPositions(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.occpb.ListExpiredPositionResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.occpb.ListExpiredPositionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.occpb.ListExpiredPositionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.occpb.ListExpiredPositionResponse.serializeBinaryToWriter = function (
  message,
  writer
) {
  var f = undefined;
  f = message.getExpiredPositionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.occpb.ExpiredPosition.serializeBinaryToWriter
    );
  }
};

/**
 * repeated ExpiredPosition expired_positions = 1;
 * @return {!Array<!proto.occpb.ExpiredPosition>}
 */
proto.occpb.ListExpiredPositionResponse.prototype.getExpiredPositionsList = function () {
  return /** @type{!Array<!proto.occpb.ExpiredPosition>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.occpb.ExpiredPosition, 1)
  );
};

/**
 * @param {!Array<!proto.occpb.ExpiredPosition>} value
 * @return {!proto.occpb.ListExpiredPositionResponse} returns this
 */
proto.occpb.ListExpiredPositionResponse.prototype.setExpiredPositionsList = function (
  value
) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};

/**
 * @param {!proto.occpb.ExpiredPosition=} opt_value
 * @param {number=} opt_index
 * @return {!proto.occpb.ExpiredPosition}
 */
proto.occpb.ListExpiredPositionResponse.prototype.addExpiredPositions = function (
  opt_value,
  opt_index
) {
  return jspb.Message.addToRepeatedWrapperField(
    this,
    1,
    opt_value,
    proto.occpb.ExpiredPosition,
    opt_index
  );
};

/**
 * Clears the list making it empty but non-null.
 * @return {!proto.occpb.ListExpiredPositionResponse} returns this
 */
proto.occpb.ListExpiredPositionResponse.prototype.clearExpiredPositionsList =
  function () {
    return this.setExpiredPositionsList([]);
  };

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.occpb.UpdateExpiredPositionRequest.prototype.toObject = function (
    opt_includeInstance
  ) {
    return proto.occpb.UpdateExpiredPositionRequest.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.occpb.UpdateExpiredPositionRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.occpb.UpdateExpiredPositionRequest.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        expiredPositionId: jspb.Message.getFieldWithDefault(msg, 1, 0),
        expirationDate:
          (f = msg.getExpirationDate()) &&
          google_type_date_pb.Date.toObject(includeInstance, f),
        entryType: jspb.Message.getFieldWithDefault(msg, 3, ''),
        qty: jspb.Message.getFieldWithDefault(msg, 4, ''),
        doNotExercise: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.occpb.UpdateExpiredPositionRequest}
 */
proto.occpb.UpdateExpiredPositionRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.occpb.UpdateExpiredPositionRequest();
  return proto.occpb.UpdateExpiredPositionRequest.deserializeBinaryFromReader(
    msg,
    reader
  );
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.occpb.UpdateExpiredPositionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.occpb.UpdateExpiredPositionRequest}
 */
proto.occpb.UpdateExpiredPositionRequest.deserializeBinaryFromReader = function (
  msg,
  reader
) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {number} */ (reader.readUint32());
        msg.setExpiredPositionId(value);
        break;
      case 2:
        var value = new google_type_date_pb.Date();
        reader.readMessage(value, google_type_date_pb.Date.deserializeBinaryFromReader);
        msg.setExpirationDate(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setEntryType(value);
        break;
      case 4:
        var value = /** @type {string} */ (reader.readString());
        msg.setQty(value);
        break;
      case 5:
        var value = /** @type {boolean} */ (reader.readBool());
        msg.setDoNotExercise(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.occpb.UpdateExpiredPositionRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.occpb.UpdateExpiredPositionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.occpb.UpdateExpiredPositionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.occpb.UpdateExpiredPositionRequest.serializeBinaryToWriter = function (
  message,
  writer
) {
  var f = undefined;
  f = message.getExpiredPositionId();
  if (f !== 0) {
    writer.writeUint32(1, f);
  }
  f = message.getExpirationDate();
  if (f != null) {
    writer.writeMessage(2, f, google_type_date_pb.Date.serializeBinaryToWriter);
  }
  f = message.getEntryType();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
  f = message.getQty();
  if (f.length > 0) {
    writer.writeString(4, f);
  }
  f = message.getDoNotExercise();
  if (f) {
    writer.writeBool(5, f);
  }
};

/**
 * optional uint32 expired_position_id = 1;
 * @return {number}
 */
proto.occpb.UpdateExpiredPositionRequest.prototype.getExpiredPositionId = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};

/**
 * @param {number} value
 * @return {!proto.occpb.UpdateExpiredPositionRequest} returns this
 */
proto.occpb.UpdateExpiredPositionRequest.prototype.setExpiredPositionId = function (
  value
) {
  return jspb.Message.setProto3IntField(this, 1, value);
};

/**
 * optional google.type.Date expiration_date = 2;
 * @return {?proto.google.type.Date}
 */
proto.occpb.UpdateExpiredPositionRequest.prototype.getExpirationDate = function () {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 2)
  );
};

/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.occpb.UpdateExpiredPositionRequest} returns this
 */
proto.occpb.UpdateExpiredPositionRequest.prototype.setExpirationDate = function (value) {
  return jspb.Message.setWrapperField(this, 2, value);
};

/**
 * Clears the message field making it undefined.
 * @return {!proto.occpb.UpdateExpiredPositionRequest} returns this
 */
proto.occpb.UpdateExpiredPositionRequest.prototype.clearExpirationDate = function () {
  return this.setExpirationDate(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.occpb.UpdateExpiredPositionRequest.prototype.hasExpirationDate = function () {
  return jspb.Message.getField(this, 2) != null;
};

/**
 * optional string entry_type = 3;
 * @return {string}
 */
proto.occpb.UpdateExpiredPositionRequest.prototype.getEntryType = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''));
};

/**
 * @param {string} value
 * @return {!proto.occpb.UpdateExpiredPositionRequest} returns this
 */
proto.occpb.UpdateExpiredPositionRequest.prototype.setEntryType = function (value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};

/**
 * optional string qty = 4;
 * @return {string}
 */
proto.occpb.UpdateExpiredPositionRequest.prototype.getQty = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ''));
};

/**
 * @param {string} value
 * @return {!proto.occpb.UpdateExpiredPositionRequest} returns this
 */
proto.occpb.UpdateExpiredPositionRequest.prototype.setQty = function (value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};

/**
 * optional bool do_not_exercise = 5;
 * @return {boolean}
 */
proto.occpb.UpdateExpiredPositionRequest.prototype.getDoNotExercise = function () {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};

/**
 * @param {boolean} value
 * @return {!proto.occpb.UpdateExpiredPositionRequest} returns this
 */
proto.occpb.UpdateExpiredPositionRequest.prototype.setDoNotExercise = function (value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.occpb.UpdateExpiredPositionResponse.prototype.toObject = function (
    opt_includeInstance
  ) {
    return proto.occpb.UpdateExpiredPositionResponse.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.occpb.UpdateExpiredPositionResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.occpb.UpdateExpiredPositionResponse.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        expiredPositions:
          (f = msg.getExpiredPositions()) &&
          proto.occpb.ExpiredPosition.toObject(includeInstance, f),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.occpb.UpdateExpiredPositionResponse}
 */
proto.occpb.UpdateExpiredPositionResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.occpb.UpdateExpiredPositionResponse();
  return proto.occpb.UpdateExpiredPositionResponse.deserializeBinaryFromReader(
    msg,
    reader
  );
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.occpb.UpdateExpiredPositionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.occpb.UpdateExpiredPositionResponse}
 */
proto.occpb.UpdateExpiredPositionResponse.deserializeBinaryFromReader = function (
  msg,
  reader
) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = new proto.occpb.ExpiredPosition();
        reader.readMessage(
          value,
          proto.occpb.ExpiredPosition.deserializeBinaryFromReader
        );
        msg.setExpiredPositions(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.occpb.UpdateExpiredPositionResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.occpb.UpdateExpiredPositionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.occpb.UpdateExpiredPositionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.occpb.UpdateExpiredPositionResponse.serializeBinaryToWriter = function (
  message,
  writer
) {
  var f = undefined;
  f = message.getExpiredPositions();
  if (f != null) {
    writer.writeMessage(1, f, proto.occpb.ExpiredPosition.serializeBinaryToWriter);
  }
};

/**
 * optional ExpiredPosition expired_positions = 1;
 * @return {?proto.occpb.ExpiredPosition}
 */
proto.occpb.UpdateExpiredPositionResponse.prototype.getExpiredPositions = function () {
  return /** @type{?proto.occpb.ExpiredPosition} */ (
    jspb.Message.getWrapperField(this, proto.occpb.ExpiredPosition, 1)
  );
};

/**
 * @param {?proto.occpb.ExpiredPosition|undefined} value
 * @return {!proto.occpb.UpdateExpiredPositionResponse} returns this
 */
proto.occpb.UpdateExpiredPositionResponse.prototype.setExpiredPositions = function (
  value
) {
  return jspb.Message.setWrapperField(this, 1, value);
};

/**
 * Clears the message field making it undefined.
 * @return {!proto.occpb.UpdateExpiredPositionResponse} returns this
 */
proto.occpb.UpdateExpiredPositionResponse.prototype.clearExpiredPositions = function () {
  return this.setExpiredPositions(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.occpb.UpdateExpiredPositionResponse.prototype.hasExpiredPositions = function () {
  return jspb.Message.getField(this, 1) != null;
};

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.occpb.ProcessExpiredPositionRequest.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.occpb.ProcessExpiredPositionRequest.prototype.toObject = function (
    opt_includeInstance
  ) {
    return proto.occpb.ProcessExpiredPositionRequest.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.occpb.ProcessExpiredPositionRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.occpb.ProcessExpiredPositionRequest.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        expiredPositionIdList:
          (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
        expirationDate:
          (f = msg.getExpirationDate()) &&
          google_type_date_pb.Date.toObject(includeInstance, f),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.occpb.ProcessExpiredPositionRequest}
 */
proto.occpb.ProcessExpiredPositionRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.occpb.ProcessExpiredPositionRequest();
  return proto.occpb.ProcessExpiredPositionRequest.deserializeBinaryFromReader(
    msg,
    reader
  );
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.occpb.ProcessExpiredPositionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.occpb.ProcessExpiredPositionRequest}
 */
proto.occpb.ProcessExpiredPositionRequest.deserializeBinaryFromReader = function (
  msg,
  reader
) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var values = /** @type {!Array<number>} */ (
          reader.isDelimited() ? reader.readPackedUint32() : [reader.readUint32()]
        );
        for (var i = 0; i < values.length; i++) {
          msg.addExpiredPositionId(values[i]);
        }
        break;
      case 2:
        var value = new google_type_date_pb.Date();
        reader.readMessage(value, google_type_date_pb.Date.deserializeBinaryFromReader);
        msg.setExpirationDate(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.occpb.ProcessExpiredPositionRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.occpb.ProcessExpiredPositionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.occpb.ProcessExpiredPositionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.occpb.ProcessExpiredPositionRequest.serializeBinaryToWriter = function (
  message,
  writer
) {
  var f = undefined;
  f = message.getExpiredPositionIdList();
  if (f.length > 0) {
    writer.writePackedUint32(1, f);
  }
  f = message.getExpirationDate();
  if (f != null) {
    writer.writeMessage(2, f, google_type_date_pb.Date.serializeBinaryToWriter);
  }
};

/**
 * repeated uint32 expired_position_id = 1;
 * @return {!Array<number>}
 */
proto.occpb.ProcessExpiredPositionRequest.prototype.getExpiredPositionIdList =
  function () {
    return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 1));
  };

/**
 * @param {!Array<number>} value
 * @return {!proto.occpb.ProcessExpiredPositionRequest} returns this
 */
proto.occpb.ProcessExpiredPositionRequest.prototype.setExpiredPositionIdList = function (
  value
) {
  return jspb.Message.setField(this, 1, value || []);
};

/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.occpb.ProcessExpiredPositionRequest} returns this
 */
proto.occpb.ProcessExpiredPositionRequest.prototype.addExpiredPositionId = function (
  value,
  opt_index
) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};

/**
 * Clears the list making it empty but non-null.
 * @return {!proto.occpb.ProcessExpiredPositionRequest} returns this
 */
proto.occpb.ProcessExpiredPositionRequest.prototype.clearExpiredPositionIdList =
  function () {
    return this.setExpiredPositionIdList([]);
  };

/**
 * optional google.type.Date expiration_date = 2;
 * @return {?proto.google.type.Date}
 */
proto.occpb.ProcessExpiredPositionRequest.prototype.getExpirationDate = function () {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 2)
  );
};

/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.occpb.ProcessExpiredPositionRequest} returns this
 */
proto.occpb.ProcessExpiredPositionRequest.prototype.setExpirationDate = function (value) {
  return jspb.Message.setWrapperField(this, 2, value);
};

/**
 * Clears the message field making it undefined.
 * @return {!proto.occpb.ProcessExpiredPositionRequest} returns this
 */
proto.occpb.ProcessExpiredPositionRequest.prototype.clearExpirationDate = function () {
  return this.setExpirationDate(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.occpb.ProcessExpiredPositionRequest.prototype.hasExpirationDate = function () {
  return jspb.Message.getField(this, 2) != null;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.occpb.BatchProcessExpiredPositionRequest.prototype.toObject = function (
    opt_includeInstance
  ) {
    return proto.occpb.BatchProcessExpiredPositionRequest.toObject(
      opt_includeInstance,
      this
    );
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.occpb.BatchProcessExpiredPositionRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.occpb.BatchProcessExpiredPositionRequest.toObject = function (
    includeInstance,
    msg
  ) {
    var f,
      obj = {
        expirationDate:
          (f = msg.getExpirationDate()) &&
          google_type_date_pb.Date.toObject(includeInstance, f),
        batchNo: jspb.Message.getFieldWithDefault(msg, 2, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.occpb.BatchProcessExpiredPositionRequest}
 */
proto.occpb.BatchProcessExpiredPositionRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.occpb.BatchProcessExpiredPositionRequest();
  return proto.occpb.BatchProcessExpiredPositionRequest.deserializeBinaryFromReader(
    msg,
    reader
  );
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.occpb.BatchProcessExpiredPositionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.occpb.BatchProcessExpiredPositionRequest}
 */
proto.occpb.BatchProcessExpiredPositionRequest.deserializeBinaryFromReader = function (
  msg,
  reader
) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = new google_type_date_pb.Date();
        reader.readMessage(value, google_type_date_pb.Date.deserializeBinaryFromReader);
        msg.setExpirationDate(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setBatchNo(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.occpb.BatchProcessExpiredPositionRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.occpb.BatchProcessExpiredPositionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.occpb.BatchProcessExpiredPositionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.occpb.BatchProcessExpiredPositionRequest.serializeBinaryToWriter = function (
  message,
  writer
) {
  var f = undefined;
  f = message.getExpirationDate();
  if (f != null) {
    writer.writeMessage(1, f, google_type_date_pb.Date.serializeBinaryToWriter);
  }
  f = message.getBatchNo();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
};

/**
 * optional google.type.Date expiration_date = 1;
 * @return {?proto.google.type.Date}
 */
proto.occpb.BatchProcessExpiredPositionRequest.prototype.getExpirationDate = function () {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 1)
  );
};

/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.occpb.BatchProcessExpiredPositionRequest} returns this
 */
proto.occpb.BatchProcessExpiredPositionRequest.prototype.setExpirationDate = function (
  value
) {
  return jspb.Message.setWrapperField(this, 1, value);
};

/**
 * Clears the message field making it undefined.
 * @return {!proto.occpb.BatchProcessExpiredPositionRequest} returns this
 */
proto.occpb.BatchProcessExpiredPositionRequest.prototype.clearExpirationDate =
  function () {
    return this.setExpirationDate(undefined);
  };

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.occpb.BatchProcessExpiredPositionRequest.prototype.hasExpirationDate = function () {
  return jspb.Message.getField(this, 1) != null;
};

/**
 * optional string batch_no = 2;
 * @return {string}
 */
proto.occpb.BatchProcessExpiredPositionRequest.prototype.getBatchNo = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ''));
};

/**
 * @param {string} value
 * @return {!proto.occpb.BatchProcessExpiredPositionRequest} returns this
 */
proto.occpb.BatchProcessExpiredPositionRequest.prototype.setBatchNo = function (value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.occpb.BatchProcessExpiredPositionResponse.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.occpb.BatchProcessExpiredPositionResponse.prototype.toObject = function (
    opt_includeInstance
  ) {
    return proto.occpb.BatchProcessExpiredPositionResponse.toObject(
      opt_includeInstance,
      this
    );
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.occpb.BatchProcessExpiredPositionResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.occpb.BatchProcessExpiredPositionResponse.toObject = function (
    includeInstance,
    msg
  ) {
    var f,
      obj = {
        expiredPositionsList: jspb.Message.toObjectList(
          msg.getExpiredPositionsList(),
          proto.occpb.ExpiredPosition.toObject,
          includeInstance
        ),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.occpb.BatchProcessExpiredPositionResponse}
 */
proto.occpb.BatchProcessExpiredPositionResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.occpb.BatchProcessExpiredPositionResponse();
  return proto.occpb.BatchProcessExpiredPositionResponse.deserializeBinaryFromReader(
    msg,
    reader
  );
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.occpb.BatchProcessExpiredPositionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.occpb.BatchProcessExpiredPositionResponse}
 */
proto.occpb.BatchProcessExpiredPositionResponse.deserializeBinaryFromReader = function (
  msg,
  reader
) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = new proto.occpb.ExpiredPosition();
        reader.readMessage(
          value,
          proto.occpb.ExpiredPosition.deserializeBinaryFromReader
        );
        msg.addExpiredPositions(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.occpb.BatchProcessExpiredPositionResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.occpb.BatchProcessExpiredPositionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.occpb.BatchProcessExpiredPositionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.occpb.BatchProcessExpiredPositionResponse.serializeBinaryToWriter = function (
  message,
  writer
) {
  var f = undefined;
  f = message.getExpiredPositionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.occpb.ExpiredPosition.serializeBinaryToWriter
    );
  }
};

/**
 * repeated ExpiredPosition expired_positions = 1;
 * @return {!Array<!proto.occpb.ExpiredPosition>}
 */
proto.occpb.BatchProcessExpiredPositionResponse.prototype.getExpiredPositionsList =
  function () {
    return /** @type{!Array<!proto.occpb.ExpiredPosition>} */ (
      jspb.Message.getRepeatedWrapperField(this, proto.occpb.ExpiredPosition, 1)
    );
  };

/**
 * @param {!Array<!proto.occpb.ExpiredPosition>} value
 * @return {!proto.occpb.BatchProcessExpiredPositionResponse} returns this
 */
proto.occpb.BatchProcessExpiredPositionResponse.prototype.setExpiredPositionsList =
  function (value) {
    return jspb.Message.setRepeatedWrapperField(this, 1, value);
  };

/**
 * @param {!proto.occpb.ExpiredPosition=} opt_value
 * @param {number=} opt_index
 * @return {!proto.occpb.ExpiredPosition}
 */
proto.occpb.BatchProcessExpiredPositionResponse.prototype.addExpiredPositions = function (
  opt_value,
  opt_index
) {
  return jspb.Message.addToRepeatedWrapperField(
    this,
    1,
    opt_value,
    proto.occpb.ExpiredPosition,
    opt_index
  );
};

/**
 * Clears the list making it empty but non-null.
 * @return {!proto.occpb.BatchProcessExpiredPositionResponse} returns this
 */
proto.occpb.BatchProcessExpiredPositionResponse.prototype.clearExpiredPositionsList =
  function () {
    return this.setExpiredPositionsList([]);
  };

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.occpb.EmptyResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.occpb.EmptyResponse.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.occpb.EmptyResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.occpb.EmptyResponse.toObject = function (includeInstance, msg) {
    var f,
      obj = {};

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.occpb.EmptyResponse}
 */
proto.occpb.EmptyResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.occpb.EmptyResponse();
  return proto.occpb.EmptyResponse.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.occpb.EmptyResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.occpb.EmptyResponse}
 */
proto.occpb.EmptyResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.occpb.EmptyResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.occpb.EmptyResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.occpb.EmptyResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.occpb.EmptyResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
};

goog.object.extend(exports, proto.occpb);
